import BasicMainCardSkin from "./basic/skins";

export { BasicMainCardSkin };

export const MAIN_SKIN_REGISTRY = {
  basic: BasicMainCardSkin,
  compact: BasicMainCardSkin,
};

export function resolveMainSkinComponent(code) {
  return MAIN_SKIN_REGISTRY[code] || BasicMainCardSkin;
}
